import React, { FC } from 'react';

import { useTranslation } from 'next-i18next/pages';

import { Button, Form, Input } from 'antd';

import { TranslationNamespace } from '@/i18n';

import styles from './InvoiceModalContent.module.scss';

type Props = {
	isLoading: boolean;
	description: string;
	onSendInvoice: (formData: InvoiceFieldType) => void;
};

export type InvoiceFieldType = {
	name: string;
	phone: string;
	email: string;
	comment?: string;
};

const initialValues: InvoiceFieldType = {
	name: '',
	phone: '',
	email: '',
	comment: '',
};

export const InvoiceModalContent: FC<Props> = ({ isLoading, description, onSendInvoice }) => {
	const t = useTranslation(TranslationNamespace.Marketing).t;

	const { TextArea } = Input;

	return (
		<div className={styles.contentContainer}>
			<div className={styles.description}>{t(description)}</div>
			<Form initialValues={initialValues} onFinish={onSendInvoice}>
				<Form.Item<InvoiceFieldType>
					name="name"
					rules={[
						{
							required: true,
							message: (
								<span style={{ padding: '4px 0', fontSize: '1.3rem' }}>
									{t('tariffs-table.invoice-modal-content.please-enter-your-name')}
								</span>
							),
						},
					]}
				>
					<Input
						className={styles.input}
						placeholder={t('tariffs-table.invoice-modal-content.your-name')}
					/>
				</Form.Item>
				<Form.Item<InvoiceFieldType> name="phone">
					<Input
						className={styles.input}
						placeholder={t('tariffs-table.invoice-modal-content.phone')}
					/>
				</Form.Item>
				<Form.Item<InvoiceFieldType>
					name="email"
					rules={[
						{
							required: true,
							type: 'email',
							message: (
								<span style={{ padding: '4px 0', fontSize: '1.3rem' }}>
									{t('tariffs-table.invoice-modal-content.please-enter-your-email-address')}
								</span>
							),
						},
					]}
				>
					<Input
						className={styles.input}
						placeholder={t('tariffs-table.invoice-modal-content.email')}
					/>
				</Form.Item>
				<Form.Item<InvoiceFieldType> name="comment">
					<TextArea
						className={styles.input}
						autoSize={{ minRows: 4, maxRows: 8 }}
						placeholder={t('tariffs-table.invoice-modal-content.additional-information')}
					/>
				</Form.Item>
				<Button
					loading={isLoading}
					className={styles.button}
					size="large"
					type="primary"
					block
					htmlType="submit"
				>
					{t('tariffs-table.invoice-modal-content.send')}
				</Button>
			</Form>
		</div>
	);
};
